import { scaleLinear } from 'd3';
import config from '../config';
import get from 'lodash/get';

const { height, width } = config.plot;

export const yScale = scaleLinear().domain([0, height])

export const xScale = scaleLinear().domain([0, width])

export const getDistance = function(a, b) {
	
	let xs = b.x - a.x;
	let ys = b.y - a.y;		
	
	xs *= xs;
	ys *= ys;
	 
	return Math.sqrt( xs + ys );
};

export const filterByKey = (sensors, key) => sensors.filter(({ data }) => get(data, [0, key]) !== undefined);

export const remapSensorKeys = (sensors, keys) => sensors.map(sensor => {
	// Some sensors return different key names for the same value so we are converting them to 
	// the expected key name so can be used without further logic effort
	Object.entries(keys).forEach(([key, nextKey]) => {
		if (sensor.data[0][key] !== undefined) sensor.data[0][nextKey] = sensor.data[0][key]
	})
	return sensor;
})

export const toDegF = degC => (degC * (9/5)) + 32

export const toDegC = degF => (degF - 32) * (5 / 9)


// WEBPACK FOOTER //
// ./src/utils/index.js